import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';

import { showQuickDepositAction } from './actions';

export const useQuickDeposit = ({ onClose }) => {
    const [hasBeenShown, setShown] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!hasBeenShown) {
            dispatch(showQuickDepositAction({ onClose }));
            setShown(true);
        }
    }, [hasBeenShown, onClose, dispatch]);
};
